/* eslint-disable space-before-function-paren */
import React, { useState, useEffect, useRef } from 'react'
import { Modal, Form, Input, Button, Checkbox, message } from 'antd'
import Tax from '@/modules/tax'

const TaxAuthModal = ({ visible, onCancel, onSuccess, data }) => {
  const [form] = Form.useForm()
  const [step, setStep] = useState(1)
  const [code, setCode] = useState('')
  const [taskId, setTaskId] = useState('')
  const [countdown, setCountdown] = useState(0)
  const [loading, setLoading] = useState(false)
  const [agreement, setAgreement] = useState(true)
  const [agreementVisible, setAgreementVisible] = useState(false)
  const timerRef = useRef(null)
  const lastClickTimeRef = useRef(0)

  useEffect(() => {
    if (visible) {
      setStep(1)
      setCode('')
      setCountdown(0)
      setAgreement(true)
      form.setFieldsValue({
        taxCityCd: '宁波市',
        loginType: '新版登录账密',
        taxCerNo: data?.custCerNo,
        username: data?.cpCellPhone,
        password: ''
      })
    }
    return () => clearInterval(timerRef.current)
  }, [visible, form, data])

  const startTimer = () => {
    setCountdown(60)
    if (timerRef.current) clearInterval(timerRef.current)
    timerRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current)
          return 0
        }
        return prev - 1
      })
    }, 1000)
  }

  const handleSendCode = async () => {
    try {
      await form.validateFields()
      if (!agreement) {
        message.error('请阅读并同意用户授权协议')
        return
      }

      setLoading(true)
      const dto = {
        taxNo: data?.custCerNo,
        smsCode: '',
        taskId: '',
        taxUserAccount: data?.cpCellPhone,
        taxUserPwd: form.getFieldValue('password')
      }
      const result = await Tax.loginSimpleWithCode(dto)
      console.log(result)
      if (result.status === 210) {
        setTaskId(result?.data)
        message.success('验证码发送成功')
        setStep(2)
        startTimer()
        return
      }
      onSuccess()
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  const handleResend = async () => {
    try {
      const dto = {
        taxNo: data?.custCerNo,
        smsCode: '',
        taskId,
        taxUserAccount: data?.cpCellPhone,
        taxUserPwd: form.getFieldValue('password')
      }
      const result = await Tax.loginSimpleWithCode(dto)
      if (result.status === 210) {
        setTaskId(result?.data)
        message.success('验证码发送成功')
        startTimer()
        return
      }
    } catch (err) {
      console.error(err)
    }
  }

  const handleConfirm = async () => {
    const now = Date.now()
    if (loading || now - lastClickTimeRef.current < 500) {
      return
    }
    lastClickTimeRef.current = now

    if (!code) {
      message.warning('请输入验证码')
      return
    }
    setLoading(true)
    const dto = {
      taxNo: data?.custCerNo,
      smsCode: code,
      taskId,
      taxUserAccount: data?.cpCellPhone,
      taxUserPwd: form.getFieldValue('password')
    }
    try {
      const result = await Tax.loginSimpleWithCode(dto)
      if (result) {
        message.success('验证成功')
        onSuccess()
      }
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  const renderStep1 = () => (
    <div style={{ padding: '0 20px' }}>
      <Form
        form={form}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
      >
        <Form.Item label='当前账套' style={{ marginBottom: 12 }}>
          <label disabled style={{ color: '#333', cursor: 'default' }} />
          <span style={{ marginLeft: 5 }}>{data.custCerNo}</span>
        </Form.Item>
        <Form.Item
          label={<span >报税所属地</span>}
          style={{ marginBottom: 12 }}
          name='taxCityCd'
          rules={[{ required: true, message: '请选择报税所属地' }]}
        >
          <Input disabled style={{ color: '#333', cursor: 'default' }} />
        </Form.Item>
        <Form.Item
          label={<span >登录方式</span>}
          style={{ marginBottom: 12 }}
          name='loginType'
          rules={[{ required: true, message: '请选择登录方式' }]}
        >
          <Input disabled style={{ color: '#333', cursor: 'default' }} />
        </Form.Item>
        <Form.Item
          label={<span >社会信用代码</span>}
          style={{ marginBottom: 12 }}
          name='taxCerNo'
          rules={[{ required: true, message: '请输入社会信用代码' }]}
        >
          <Input disabled style={{ color: '#333', cursor: 'default' }} />
        </Form.Item>
        <Form.Item
          label={<span >用户名</span>}
          style={{ marginBottom: 12 }}
          name='username'
          rules={[{ required: true, message: '请输入用户名' }]}
        >
          <Input disabled style={{ color: '#333', cursor: 'default' }} />
        </Form.Item>
        <Form.Item
          label={<span >用户密码</span>}
          style={{ marginBottom: 12 }}
          name='password'
          rules={[{ required: true, message: '请输入用户密码' }]}
        >
          <Input.Password
            placeholder='请输入用户密码'
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: 24, marginLeft: 16, marginTop: 12 }}>
          <Checkbox checked={agreement} onChange={(e) => setAgreement(e.target.checked)}>
            我已阅读并同意 <a onClick={() => setAgreementVisible(true)}>《用户授权协议》</a>
          </Checkbox>
        </Form.Item>
        <div style={{ textAlign: 'right' }}>
          <Button onClick={onCancel} style={{ marginRight: 12 }}>取消</Button>
          <Button type='primary' onClick={handleSendCode} loading={loading}>发送验证码</Button>
        </div>
      </Form>
    </div>
  )

  const renderStep2 = () => (
    <div style={{ padding: '20px 20px', textAlign: 'left' }}>
      <p style={{ marginBottom: 20, fontSize: 14, marginLeft: 40 }}>手机号   <span style={{ marginLeft: 5 }}>{data.cpCellPhone?.replace(/(\d{3})\d{6}(\d{2})/, '$1******$2')}</span></p>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 30 }}>
        <span style={{ color: 'red', marginRight: 5 }}>*</span>
        <span style={{ marginRight: 10 }}>手机动态码</span>
        <Input
          style={{ width: 160, marginRight: 10 }}
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
        <Button disabled={countdown > 0} onClick={handleResend} style={{ width: 100 }}>
          {countdown > 0 ? countdown : '发送验证码'}
        </Button>
      </div>
      <div style={{ textAlign: 'center' }}>
        <Button onClick={onCancel} style={{ marginRight: 12 }}>取消</Button>
        <Button type='primary' onClick={handleConfirm} loading={loading}>确定</Button>
      </div>
    </div>
  )

  return (
    <>
      <Modal
        title='电子税务局账号认证'
        visible={visible}
        onCancel={onCancel}
        maskClosable={false}
        footer={null}
        width={step === 1 ? 500 : 450}
        centered
        destroyOnClose
      >
        {step === 1 ? renderStep1() : renderStep2()}
      </Modal>
      <Modal
        title='用户授权协议'
        visible={agreementVisible}
        onCancel={() => setAgreementVisible(false)}
        maskClosable={false}
        footer={null}
        width={800}
        centered
        destroyOnClose
        bodyStyle={{ padding: 0, height: '600px', overflow: 'hidden' }}
      >
        <iframe
          src='https://oss.gerlun.com/files/agreement/tax-issue.html'
          style={{ width: '100%', height: '100%', border: 'none' }}
          title='User Agreement'
        />
      </Modal>
    </>
  )
}

export default TaxAuthModal
